// extracted by mini-css-extract-plugin
module.exports = {"container":"UserProfile_container__HwkUg","leftColumn":"UserProfile_leftColumn__n_Isj"};